import { useState, FC, useCallback, useEffect } from 'react';
import { FormControl, TextField } from '@mui/material';
import { DeloitteDialog } from 'TaxAnalyticsUI/Deloitte';
import { ContactMessage } from 'TaxAnalyticsHelpers/TaxAnalyticsClient';
import { ApiClient } from 'TaxAnalyticsHelpers';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { tag } from 'TaxAnalyticsHelpers/ATInternet';

interface IContactFormProps {
    open: boolean,
    closeCallback: () => void;
}

const ContactForm: FC<IContactFormProps> = (props) => {
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [formState, setFormState] = useState<ContactMessage>({
        firstName: '',
        lastName: '',
        contactEmail: '',
        message: '',
        subject: ''
    });

    const resetFormState = () => {
        setFormState({
            firstName: '',
            lastName: '',
            contactEmail: '',
            message: '',
            subject: ''
        });
    }

    const UpdateFormState = (formData: ContactMessage) => {
        setFormState(formData);
    }

    const handleSendContactMessage = useCallback(async () => {
        if (!executeRecaptcha) {
            console.log('Execute recaptcha not yet available');
            return;
        }

        const token = await executeRecaptcha('contact/send');
        await ApiClient.portalClient.contact(formState, true, token);

        resetFormState();
        props.closeCallback();
    }, [executeRecaptcha, formState]);

    useEffect(() => {
        if (props.open)
            tag.sendPage({
                name: `Home - Contact`
            });
    }, []);

    return (
        <DeloitteDialog title="Demande d'information" open={props.open} closeCallback={() => props.closeCallback()} actionTitle="Envoyer" bottomAction={handleSendContactMessage}>
            <FormControl fullWidth component="fieldset" variant="standard" sx={{ marginTop: 1 }}>
                <TextField
                    id="lastName"
                    label="Nom"
                    value={formState.lastName}
                    onChange={(event) => UpdateFormState({ ...formState, lastName: event.target.value })}
                    variant="standard"
                    color="secondary"
                    autoComplete='off'
                />
            </FormControl>
            <FormControl fullWidth component="fieldset" variant="standard" sx={{ marginTop: 1 }}>
                <TextField
                    id="firstName"
                    label="Prénom"
                    value={formState.firstName}
                    onChange={(event) => UpdateFormState({ ...formState, firstName: event.target.value })}
                    variant="standard"
                    color="secondary"
                    autoComplete='off'
                />
            </FormControl>
            <FormControl fullWidth component="fieldset" variant="standard" sx={{ marginTop: 1 }}>
                <TextField
                    id="email"
                    label="Email"
                    value={formState.contactEmail}
                    onChange={(event) => UpdateFormState({ ...formState, contactEmail: event.target.value })}
                    variant="standard"
                    autoComplete='off'
                />
            </FormControl>
            <FormControl fullWidth component="fieldset" variant="standard" sx={{ marginTop: 1 }}>
                <TextField
                    id="subject"
                    label="Sujet"
                    value={formState.subject}
                    onChange={(event) => UpdateFormState({ ...formState, subject: event.target.value })}
                    variant="standard"
                    color="secondary"
                    autoComplete='off'
                />
            </FormControl>
            <FormControl fullWidth component="fieldset" variant="standard" sx={{ marginTop: 1 }}>
                <TextField
                    id="message"
                    label="Message"
                    multiline
                    value={formState.message}
                    onChange={(event) => UpdateFormState({ ...formState, message: event.target.value })}
                    variant="standard"
                    minRows={3}
                    color="secondary"
                    autoComplete='off'
                />
            </FormControl>
        </DeloitteDialog>
    );
}

export default ContactForm;